import Store from 'store/store';

Store.on('ASSETS_LOADED', () => {
	console.log('Assets Loaded');
});

Store.on('INTERSTITIAL_BUTTON_CLICKED', () => {
	console.log('Interstitial Button Clicked!');
});

Store.on('INTRO_VIDEO_PLAYING', () => {
	console.log('Intro Video Playing');
});

Store.on('SKIP_PORTAL', () => {
	console.log('Skip Portal');
});

Store.on('PORTAL_ANIMATION_STARTED', () => {
	console.log('Portal Animation Started!');
});

Store.on('SCROLL_TO_CONTENT', () => {
	console.log('scroll to content!');
});

Store.on('CONTENT_TRANSITION_STARTED', () => {
	console.log('Content Transition Started!');
});

Store.on('SCROLL_TO_GIFT', () => {
	console.log('scroll to gift!');
});

Store.on('GIFT_TRANSITION_STARTED', () => {
	console.log('Gift Transition Started');
});

Store.on('PORTAL_ANIMATION_ENDED', () => {
	console.log('Portal Animation Ended!');
});

Store.on('SHOW_CONTENT_SCROLL_PROMPT', () => {
	console.log('Show Content Scroll Prompt!');
});

Store.on('PORTALS_BUTTON_CLICKED', () => {
	console.log('Portals Button Clicked');
});

Store.on('CONTENT_TRANSITION_ENDED', () => {
	console.log('Content Transition Ended');
});

Store.on('FINAL_TRANSITION_ENDING', () => {
	console.log('Final Transition Ending');
});

Store.on('SCROLL_TO_PORTALS', (page) => {
	Store.get().set({ comingFrom: page });
	Store.emit('CLOSE_AND_NAVIGATE', 'portals');
});

Store.on('TOGGLE_FULLSCREEN', (bool) => {
	Store.get().set({ fullscreen: bool });
});

Store.on('TOGGLE_OVERLAY_OPEN', (bool) => {
	console.log('Toggle Overlay Open: ' + bool);
});

Store.on('SOUND_LOADED', () => {
	Store.get().set({ soundLoaded: true });
});

Store.on('HOLDING_PAGE_LOADED', () => {
	Store.get().header.set({
		holdingPageLoaded: true
	});
});
